import React from "react";
import { css, useTheme } from "@emotion/react";

type Props = {
    children: React.ReactNode,
};

const BurgerNavHeaderContainer: React.FC<Props> = ({
    children,
}) => {
    const theme = useTheme();

    const style = css`
        background-color: ${theme.colours.white};
    `;

    return (
        <div css={style}>
            {children}
        </div>
    );
};

export default BurgerNavHeaderContainer;